<infigo-detail-block>
	<app-skeleton [height]="'200px'" [loading]="loading">
		<n-tab
            [(activeItem)]="activeTabItem"
            [type]="'card'"
            class="only-one-tab"
            style="height: calc(100% - 0.33rem)"
        >
			<n-tab-item [header]="defaultTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-mapping-table #mappingTable [data]="mappingList" [loading]="updateLoading" [type]="'lun'"></app-mapping-table>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
		</n-tab>
	</app-skeleton>
</infigo-detail-block>
